<template>
  <div id="rowWrapper">
    <h6 class="main-color font-bold">{{ nameOfCriteria }}</h6>

    <div v-if="isOverallValue" id="overallValueInput">
      <b-form-input id="rangeOverallValueInput" v-model="counterRangeRaw" type="range" min="50" max="150"></b-form-input>
      <b-form-input
        id="rangeOverallValueNumber"
        v-model.number="counterRangeRaw"
        type="number"
        min="50"
        max="150"
        @change="clampOverallValue"
      ></b-form-input>
    </div>

    <div v-else id="ownInput">
      <b-button id="subtractButton" @click="decrementCounter"><i class="bi bi-dash"></i></b-button>
      <b-form-input id="countInput" v-model.number="counterRaw" type="number" min="1" max="5" @change="onCriteriaInput"></b-form-input>
      <b-button id="addButton" @click="incrementCounter"> <i class="bi bi-plus"></i> </b-button>
    </div>

    <p v-if="isOverallValue"></p>
    <p v-else class="main-color font-bold">{{ intEvaluationToString[counterRaw] }}</p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  props: { nameOfCriteria: String, targetedUserId: Number, isOverallValue: Boolean, value: Number },
  data() {
    return {
      localeConsts: {
        bad: 'PEERREVIEW.BAD',
        improvable: 'PEERREVIEW.IMPROVABLE',
        okay: 'PEERREVIEW.OKAY',
        great: 'PEERREVIEW.GREAT',
        excellent: 'PEERREVIEW.EXCELLENT'
      },
      counterRaw: this.value || 1,
      counterRangeRaw: this.value || 50,
      criteriaNameCopy: ` ${this.nameOfCriteria}`.slice(1)
    }
  },
  computed: {
    counter() {
      return this.counterRaw
    },

    intEvaluationToString() {
      return {
        1: this.$i18n.t(this.localeConsts.bad),
        2: this.$i18n.t(this.localeConsts.improvable),
        3: this.$i18n.t(this.localeConsts.okay),
        4: this.$i18n.t(this.localeConsts.great),
        5: this.$i18n.t(this.localeConsts.excellent)
      }
    },
    isThisTheOverallValue() {
      return this.criteriaNameCopy === this.$i18n.t('PEERREVIEW.OVERALLVALUE')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.isOverallValue) {
          this.counterRangeRaw = newVal || 50
        } else {
          this.counterRaw = newVal || 1
        }
      }
    },
    //eslint-disable-next-line
    counterRangeRaw: function (newValue, oldValue) {
      this.setOverallRangeValue({ key: this.targetedUserId, overallRangeValue: this.counterRangeRaw })
      this.$emit('valueChanged', parseInt(this.counterRangeRaw))
    }
  },
  created() {
    if (this.isOverallValue) {
      this.setOverallRangeValue({ key: this.targetedUserId, overallRangeValue: this.counterRangeRaw })
    }
  },
  methods: {
    ...mapMutations('peerReview', ['setOverallRangeValue']),
    incrementCounter() {
      this.counterRaw + 1 > 5 ? (this.counterRaw = 5) : this.counterRaw++
      this.$emit('valueChanged', this.counterRaw)
    },
    decrementCounter() {
      this.counterRaw - 1 < 1 ? (this.counterRaw = 1) : this.counterRaw--
      this.$emit('valueChanged', this.counterRaw)
    },
    onCriteriaInput() {
      if (this.counterRaw < 1) this.counterRaw = 1
      if (this.counterRaw > 5) this.counterRaw = 5
      this.$emit('valueChanged', this.counterRaw)
    },
    clampOverallValue() {
      if (this.counterRangeRaw < 50) this.counterRangeRaw = 50
      if (this.counterRangeRaw > 150) this.counterRangeRaw = 150
    }
  }
}
</script>

<style>
#rowWrapper {
  display: grid;
  align-items: baseline;
  grid-template-columns: 2fr 2fr 160px;
  margin-bottom: 10px;
}

#overallValueInput {
  display: flex;
  align-items: center;
  gap: 8px;
}

#rangeOverallValueInput {
  width: 150px;
}

#rangeOverallValueNumber {
  width: 70px;
  text-align: center;
}

#ownInput {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border: solid gray 1px;
  width: fit-content;
  padding: 0px;
  border-radius: 5px;
  margin: 0px 50px;
}

#subtractButton {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

#countInput {
  border: none;
  border-left: solid gray 1px;
  border-right: solid gray 1px;
  border-radius: 0 !important;
  text-align: center;
  width: 50px;
  padding: 0;
}

#addButton {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
</style>
